export default "__VITE_ASSET__DkaRj$DX__"